import { render, staticRenderFns } from "./webdesign.vue?vue&type=template&id=af72c478&scoped=true&"
import script from "./webdesign.vue?vue&type=script&lang=js&"
export * from "./webdesign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af72c478",
  null
  
)

export default component.exports